var App = angular.module('myApp', [
    'ngDialog',
    'oc.lazyLoad',
    'toastr',
    'ngStorage',
    'ngCookies',
    'ui.bootstrap',
    'ui.router',
    'angular-svg-round-progressbar',
    'ngSanitize', //Sanitizes an html string by stripping all potentially dangerous tokens
    //'ngTouch',
    'ngMaterial',
    'ngMessages',
    'sb.checkbox',
    'darthwade.dwLoading',
    'duScroll',
    'ngComboDatePicker',
    'ngFileSaver',
    'praos.briefcase',
    //'ngImgCrop',
    //'ngCropper',
    'uiCropper',
    'ngIdle'
]);

App.config(function ($mdThemingProvider) {

});

App.config(function (toastrConfig) {
    angular.extend(toastrConfig, {
        autoDismiss: true,
        maxOpened: 1,
        newestOnTop: true,
        positionClass: 'toast-top-right'
    });
});

App.run(['$rootScope', '$state', '$localStorage', 'sessionService', 'sessionTimeout', 'errorHandler', '$location', function ($rootScope, $state, $localStorage, sessionService, sessionTimeout, errorHandler, $location) {
    const token = $localStorage['token'];
    if(token){
        errorHandler.run();
        sessionService.updateProfessional();
        sessionService.updateNotifications();
        sessionTimeout.start(token);
    }
    $rootScope.$on('updateProfile', sessionService.updateProfessional.bind(sessionService));
    $rootScope.$on('completeBriefcase', () => $state.go('success'));
    $rootScope.$on('updateProfileAvatar', (av, url) => sessionService.setAvatar(url));
    $rootScope.$on('updateNotifications', sessionService.updateNotifications.bind(sessionService));
    $rootScope.$on('$stateChangeStart',
        function(event, toState, params) {
        if(_.get(toState, 'data.main')){
            return;
        }

        if(toState.name === 'verify'){
            delete $localStorage.token;
        }

        if(_.get(toState, 'data.requiresLogin')){
            if(!$localStorage['token']){
                errorHandler.stop();
                sessionTimeout.stop();
                event.preventDefault();
                const coBrandedToken = $location.$$search.coBrandedUrl;
                const r = JSON.stringify({ state: toState.name, params });
                if(coBrandedToken){
                    return $state.go('coBrandedLogin', { coBrandedKEY: coBrandedToken, r });
                } else {
                    return $state.go('login', { r });
                }
            }  else if (_.get(toState, 'data.briefcaseMinStep') && sessionService.sessionStorage && sessionService.sessionStorage['professional']) {
                const briefcaseTabs = [
                    'dashboard.profile',
                    'dashboard.license',
                    'dashboard.education',
                    'dashboard.tasks',
                    'dashboard.documents',
                ];
                const briefcaseMinStep = _.get(toState, 'data.briefcaseMinStep');
                const userCurrentStep = _.get(sessionService.sessionStorage['professional'], 'briefcase.currentStep', 0);
                if (userCurrentStep < briefcaseMinStep) {
                    return $state.go(briefcaseTabs[userCurrentStep]);
                }
            }
        } else {
            if($localStorage['token']){
                if(toState.name === 'contact' || toState.name === 'contactme'){
                    return;
                } else {
                    event.preventDefault();
                    return $state.go('splash');
                }
            }
        }
        });
    $rootScope.isSafariBrowser = true;
}]);